import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoadingSubject.asObservable();
  private readonly zIndexSubject = new BehaviorSubject<number>(10000);
  public zIndex$ = this.zIndexSubject.asObservable();

  private setLoading(isLoading: boolean): void {
    const zIndex = this.calculateZIndex();
    this.setZIndex(zIndex);
    this.isLoadingSubject.next(isLoading);
  }

  public show(): void {
    const isLoading = true;
    this.setLoading(isLoading);
  }

  public hide(): void {
    const isLoading = false;
    this.setLoading(isLoading);
  }

  private setZIndex(zIndex: number): void {
    this.zIndexSubject.next(zIndex);
  }

  private calculateZIndex(): number {
    return Math.floor(Math.random() * 1000) + this.zIndexSubject.getValue();
  }
}
